

define(['angular', './error', './fallback', './contingency', './metaBuilder', './middleware', './miniBrowser'], function (angular) {

    angular.module('hermes.lib', ['hermes.lib.error', 'hermes.lib.fallback', 'hermes.lib.contingency', 'hermes.lib.metadata', 'hermes.lib.middleware', 'hermes.lib.minibrowser']);
});


//////////////////
// WEBPACK FOOTER
// ./js/lib/index.js
// module id = ./js/lib/index.js
// module chunks = 1